/*
 * Пометка «авто»: размеры и шрифт — от `.pill` (base.css), цвет — свой. Контур фиолетовым
 * без заливки: не совпадает ни с одним статусом (залитые пилюли) и не с архивом (`.st-new`,
 * пунктир серым) — docs/ui-design.md §2.1.
 */
.auto {
  background: transparent;
  color: var(--accent-ink);
  border: 1px solid var(--violet-bg-2);
  /* Рамка добавляет 2px высоты; паддинг ужат на столько же, чтобы строка с двумя пилюлями
     не прыгала относительно строки с одной. */
  padding: 3px 9px;
}
